import { render, staticRenderFns } from "./FinanceExpenses.vue?vue&type=template&id=f2e2f0a2&scoped=true"
import script from "./FinanceExpenses.vue?vue&type=script&lang=js"
export * from "./FinanceExpenses.vue?vue&type=script&lang=js"
import style0 from "./FinanceExpenses.vue?vue&type=style&index=0&id=f2e2f0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e2f0a2",
  null
  
)

export default component.exports